module.exports = __webpack_public_path__ + "img/update-small-icon.0e1f2d3f.svg";